import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import JobContests from './JobContests';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Job Contests | Admin',
    component: (
      <AdminLayout>
        <JobContests />
      </AdminLayout>
    ),
  };
}

export default action;
